import styled from "styled-components";

export const AdminPre = styled.pre`
  text-align: left;
  text-wrap: wrap;
`;
